
import { Component, Prop, Vue } from "vue-property-decorator";

const ICONS = {
  collapse: "layout-sidebar-left-collapse",
  expand: "layout-sidebar-left-expand-filled",
};

const CLASS = "sidebar-view-control";

@Component
export default class AppSidebarViewControl extends Vue {
  @Prop({ type: Boolean, default: false }) readonly selected: boolean;
  @Prop({ type: Boolean, default: false }) readonly collapsed!: boolean;

  icons = ICONS;

  get classes() {
    return {
      [`${CLASS}_selected`]: this.selected,
    };
  }

  get icon() {
    return !this.collapsed ? ICONS.collapse : ICONS.expand;
  }
}
